import { useContext } from "react";

import { ServerInformationContext } from "../contexts";

export const useSystemInformation = () => {
  const serverInformationContext = useContext(ServerInformationContext);
 
  
  return {
    hubClients: serverInformationContext.hubClients,
    setHubClients: serverInformationContext.setHubClients,
    systemInfoPanelVisible: serverInformationContext.showSystemInfoPanel,
    usePanelWrapper: serverInformationContext.usePanelWrapper,
    usePanelIcon: serverInformationContext.usePanelIcon,
    panelContent: serverInformationContext.panelContent,
    showSystemInfoPanel: serverInformationContext.showSystemInfoPanel,
    hideSystemInfoPanel: serverInformationContext.hideSystemInfoPanel
  }
}
